var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-iframe-box"},[_c('iframe',{staticClass:"pdf-iframe",staticStyle:{"width":"100vw","height":"100vh"},attrs:{"src":_vm.pdfUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }